import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import { RadioGroup } from "@headlessui/react"
import { useState } from "react"
import { navigate } from "gatsby"

function classNames(...classes) {
  return classes.filter(Boolean).join(" ")
}

function MaturityModel() {
  const data = useStaticQuery(
    graphql`
      query {
        allDimensionsJson {
          nodes {
            id
            name
            attributes {
              name
              questions {
                key
                text
                levels {
                  text
                  points
                }
              }
            }
          }
        }
      }
    `
  )
  const [state, setState] = useState({
    "ml-support": 1,
    "ml-strategy": 1,
    "ml-resources": 1,
    "ml-financing": 1,
    "ml-expertise": 1,
    "physician-acceptance": 1,
    "patient-acceptance": 1,
    "data-digitization": 1,
    "data-formats": 1,
    "data-quality": 1,
    "data-value": 1,
    "data-representativeness": 1,
  })
  const handleInputChange = event => {
    const { name, value } = event
    setState(prevState => ({
      ...prevState,
      [name]: value,
    }))
  }
  const handleSubmit = event => {
    event.preventDefault()
    navigate("/results/", { state: state })
  }
  return (
    <form
      id="questionnaire"
      className="space-y-8 divide-y divide-gray-200"
      onSubmit={handleSubmit}
    >
      <div className="space-y-8 divide-y divide-gray-200 sm:space-y-5">
        <div>
          {data.allDimensionsJson.nodes.map(dim => (
            <div className="bg-white shadow overflow-hidden sm:rounded-md max-w-6xl my-4 mx-auto px-4 py-4 sm:px-6 lg:px-8 sm:py-6 lg:py-8">
              <div className="">
                <h2 className="text-xl leading-6 font-medium text-gray-900">
                  {dim.name}
                </h2>
                <p className="mt-1 max-w-2xl text-sm text-gray-500">
                  For each question, please select the attribute most accurately
                  describing the situation in your clinic.
                </p>
              </div>
              <div className="mt-4 sm:mt-0 space-y-6 sm:space-y-5">
                {dim.attributes.map(attr => (
                  <div className="sm:pt-6">
                    <h3 className="text-base leading-6 font-medium text-gray-900">
                      {attr.name}
                    </h3>
                    <div className="sm:grid sm:grid-cols-3 sm:gap-10 sm:items-start sm:border-t sm:border-gray-200 sm:pt-4">
                      {attr.questions.map(question => (
                        <>
                          <label
                            htmlFor={question.key}
                            className="block text-sm font-medium text-gray-700 pt-1 sm:mt-px sm:pt-2"
                          >
                            {question.text}
                          </label>
                          <div className="mt-1 sm:mt-0 sm:col-span-2">
                            <RadioGroup
                              id={question.key}
                              value={state[question.key]}
                              onChange={value =>
                                handleInputChange({
                                  name: question.key,
                                  value: value,
                                })
                              }
                            >
                              <RadioGroup.Label className="sr-only">
                                Server size
                              </RadioGroup.Label>
                              <div className="space-y-4">
                                {question.levels.map(option => (
                                  <RadioGroup.Option
                                    key={option.points}
                                    value={option.points}
                                    className={({ active }) =>
                                      classNames(
                                        active
                                          ? "ring-1 ring-offset-2 ring-indigo-500"
                                          : "",
                                        "relative block rounded-lg border border-gray-300 bg-white shadow-sm px-6 py-4 cursor-pointer hover:border-gray-400 sm:flex sm:justify-between focus:outline-none"
                                      )
                                    }
                                  >
                                    {({ checked }) => (
                                      <>
                                        <div className="flex items-center">
                                          <div className="text-sm">
                                            <RadioGroup.Label
                                              as="p"
                                              className="font-medium text-gray-900"
                                            >
                                              {option.text}
                                            </RadioGroup.Label>
                                          </div>
                                        </div>
                                        <div
                                          className={classNames(
                                            checked
                                              ? "border-indigo-500"
                                              : "border-transparent",
                                            "absolute -inset-px rounded-lg border-2 pointer-events-none"
                                          )}
                                          aria-hidden="true"
                                        />
                                      </>
                                    )}
                                  </RadioGroup.Option>
                                ))}
                              </div>
                            </RadioGroup>
                          </div>
                        </>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
        <div className="max-w-6xl mx-auto border-none">
          <div className="flex justify-end">
            <button
              type="submit"
              className="ml-3 inline-flex justify-center py-2 px-4 mb-4 shadow-sm text-xl font-bold rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            >
              Calculate maturity score
            </button>
          </div>
        </div>
      </div>
    </form>
  )
}

export default MaturityModel
